<div class="product-detail-container">
  <!-- Header with Return Button -->
  <div class="header-section">
    <div class="header-content">
      <h1 class="page-title">{{ "goods.product_review.detail.view_title" | translate }}</h1>
      <button
        pButton
        type="button"
        [label]="'goods.product_review.detail.actions.back' | translate"
        class="p-button-secondary return-button"
        (click)="onReturn()"
      ></button>
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
  <div class="loading-container">
    <p>{{ "goods.product_review.detail.messages.loading" | translate }}</p>
  </div>
  }

  <!-- Error State -->
  @if (error() && !isLoading()) {
  <div class="error-container">
    <p class="error-message">{{ error() }}</p>
      <button
        pButton
        type="button"
        [label]="'goods.product_review.detail.actions.retry' | translate"
        class="p-button-secondary"
        (click)="loadProductDetail()"
      ></button>
  </div>
  }

  <!-- Product Details Content -->
  @if (productDetail() && !isLoading()) {
  <div class="detail-content">
    <!-- Basic Information Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.basic_information" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.sku_name" | translate }}</div>
            <div class="info-value">{{ productDetail()?.skuName }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.sku_code" | translate }}</div>
            <div class="info-value">{{ productDetail()?.skuCode }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_name" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productName }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_code" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productCode }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_category" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productCategories }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_brand" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productBrand }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SKU Attributes Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.sku_attributes" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <!-- Always show product dimensions -->
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_weight" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productWeight || "0" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_length" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productLength || "0" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_width" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productWidth || "0" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_height" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productHeight || "0" }}
            </div>
          </div>

          <!-- Dynamic attributes from skuAttributeList -->
          @for (attr of productDetail()?.skuAttributeList || []; track attr?.id)
          {
          <div class="info-row">
            <div class="info-label">
              {{ attr?.attributeName || ("goods.product_review.detail.fields.attribute" | translate) }}
            </div>
            <div class="info-value">{{ attr?.attributeValue || ("goods.product_review.detail.values.na" | translate) }}</div>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- SKU Price Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.sku_prices" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.cost_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.costPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.sales_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.salesPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.promotional_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.marketingPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.market_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.marketPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.distribution_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.distributionPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.wholesale_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.wholesalePrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.clearance_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.settlementPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.promotion_price" | translate }}</div>
            <div class="info-value">
              {{
                productDetail()?.internalApportionmentPrice | number : "1.2-2"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Other Attributes Section -->
    @if ((productDetail()?.otherAttributeList?.length ?? 0) > 0) {
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.other_attributes" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          @for (attr of productDetail()?.otherAttributeList || []; track
          attr?.id) {
          <div class="info-row">
            <div class="info-label">{{ attr?.name || ("goods.product_review.detail.fields.attribute" | translate) }}</div>
            <div class="info-value">{{ attr?.value || ("goods.product_review.detail.values.na" | translate) }}</div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Package Details Section -->
    @if ((productDetail()?.skuDetailList?.length ?? 0) > 0) {
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.package_details" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          @for (detail of productDetail()?.skuDetailList || []; track
          detail?.id) {
          <div class="info-row">
            <div class="info-label">
              {{ detail?.skuName || ("goods.product_review.detail.fields.package_item" | translate) }}
            </div>
            <div class="info-value">
              {{ detail?.quantity || 1 }} x {{ detail?.skuCode || ("goods.product_review.detail.values.na" | translate) }}
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Product Assets Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.product_assets" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="materials-grid">
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.asset_name" | translate }}</div>
            <div class="material-content">
              <div class="asset-name-value">
                {{
                  productDetail()?.materialName || ("goods.product_review.detail.values.product_asset_collection" | translate)
                }}
              </div>
            </div>
          </div>
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.main_images" | translate }}</div>
            <div class="material-content">
              @if (productDetail()?.mainImage) {
              <div class="image-placeholder">
                <img
                  [src]="productDetail()?.mainImage"
                  alt="Main Image"
                  class="material-image"
                />
              </div>
              } @else {
              <div class="no-image">{{ "goods.product_review.detail.values.na" | translate }}</div>
              }
            </div>
          </div>
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.detail_images" | translate }}</div>
            <div class="material-content">
              @if (productDetail()?.detailedImage) {
              <div class="image-placeholder">
                <img
                  [src]="productDetail()?.detailedImage"
                  alt="Detailed Image"
                  class="material-image"
                />
              </div>
              } @else {
              <div class="no-image">{{ "goods.product_review.detail.values.na" | translate }}</div>
              }
            </div>
          </div>
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.product_description" | translate }}</div>
            <div class="material-content">
              <div class="description-content">
                <p class="description-text">
                  {{
                    productDetail()?.productDescription ||
                      ("goods.product_review.detail.values.no_description" | translate)
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Approval Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.approval_information" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.submitted_by" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.auditCommitBy || ("goods.product_review.detail.values.na" | translate) }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.status" | translate }}</div>
            <div class="info-value">
              {{ getStatusLabel(productDetail()?.status) || ("goods.product_review.detail.values.na" | translate) }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.audit_comment" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.submittedBy || ("goods.product_review.detail.values.no_comment" | translate) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
